import React, { useMemo, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Button, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PeopleIcon from '@mui/icons-material/People';
import AssessmentIcon from '@mui/icons-material/Assessment';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import CustomerOrdersPage from './CustomerOrdersPage';
import CustomersPage from './CustomersPage';
import OrdersAnalyticsPage from './OrdersAnalyticsPage';
import PositionsLogPage from './PositionsLogPage';
import KitsLogPage from './KitsLogPage';

const TABS = [
  { id: 'orders', label: 'Активні замовлення', icon: <ListAltIcon fontSize="small" /> },
  { id: 'customers', label: 'Журнал замовників', icon: <PeopleIcon fontSize="small" /> },
  { id: 'analytics-orders', label: 'Аналітика замовлень', icon: <AssessmentIcon fontSize="small" /> },
  { id: 'analytics-customers', label: 'Аналітика замовників', icon: <AssessmentIcon fontSize="small" /> },
  { id: 'positions', label: 'Журнал позицій', icon: <FactCheckOutlinedIcon fontSize="small" /> },
  { id: 'kits', label: 'Журнал комплектів', icon: <FactCheckOutlinedIcon fontSize="small" /> },
];

function CustomerOrdersHubPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const ordersPageRef = useRef(null);

  const activeTab = useMemo(() => {
    const tab = searchParams.get('tab');
    return TABS.some((t) => t.id === tab) ? tab : 'orders';
  }, [searchParams]);

  const setActiveTab = (tab) => {
    setSearchParams(tab === 'orders' ? {} : { tab });
  };

  const handleAddOrder = () => {
    setActiveTab('orders');
    ordersPageRef.current?.openNewOrder();
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 3 }}>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleAddOrder}>
          Додати замовлення
        </Button>
        {TABS.map((t) => (
          <Button
            key={t.id}
            variant={activeTab === t.id ? 'contained' : 'outlined'}
            startIcon={t.icon}
            onClick={() => setActiveTab(t.id)}
          >
            {t.label}
          </Button>
        ))}
      </Stack>

      <Box sx={{ display: activeTab === 'orders' ? 'block' : 'none' }}>
        <CustomerOrdersPage ref={ordersPageRef} />
      </Box>
      <Box sx={{ display: activeTab === 'customers' ? 'block' : 'none' }}>
        <CustomersPage />
      </Box>
      <Box sx={{ display: activeTab === 'analytics-orders' ? 'block' : 'none' }}>
        <OrdersAnalyticsPage report="orders" />
      </Box>
      <Box sx={{ display: activeTab === 'analytics-customers' ? 'block' : 'none' }}>
        <OrdersAnalyticsPage report="customers" />
      </Box>
      <Box sx={{ display: activeTab === 'positions' ? 'block' : 'none' }}>
        <PositionsLogPage />
      </Box>
      <Box sx={{ display: activeTab === 'kits' ? 'block' : 'none' }}>
        <KitsLogPage />
      </Box>
    </Box>
  );
}

export default CustomerOrdersHubPage;
